import { CdkDrag, CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { AfterViewInit, Component, ElementRef, Inject, Input, OnInit, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '../../../../../node_modules/@angular/router';
import { ClassroomSummary } from '../../../classroom360/classroom-summary/models/classroom-summary.model';
import { Classroom360Service } from '../../../classroom360/classroom360.service';
import { GradebookPreferences } from '../../../classroom360/gradebook/shared/models/preferences/gradebook-preferences.model';
import { GradebookV9Service } from '../../../classroom360/gradebook/v9/gradebook-v9.service';
import { SpecialMark } from '../../../classroom360/gradebook/v9/models/special-mark.model';
import { LoginService } from '../../../shared-modules/login/login.service';
import { ErrorList } from '../../controls/error-prompt/error-list.model';
import { GeneralConfirmationComponent } from '../../controls/general-confirmation/general-confirmation.component';
import { CustomLayoutsService } from '../../custom-layouts/custom-layouts.service';
import { LayoutEditorComponent } from '../../custom-layouts/layout-editor/layout-editor.component';
import { CustomLayoutSchoolDefault } from '../../custom-layouts/Models/custom-layout-school-default.model';
import { CustomLayout } from '../../custom-layouts/Models/custom-layout.model';
import { SavedLayoutsDialogComponent } from '../../custom-layouts/saved-layouts-dialog/saved-layouts-dialog.component';
import { FavoritesComponent } from '../../favorites/favorites.component';
import { Portal } from '../../portal.model';
import { SecurityService } from '../../security/security.service';
import { SharedService } from '../../shared.service';
import { UserPermission } from '../../user/user-permission.model';
import { UserSchoolYearPolicies } from '../../user/user-school-year-policies.model';
import { User } from '../../user/user.model';
import { UserService } from '../../user/user.service';
import { School } from '../../year/school.model';
import { Year } from '../../year/year.model';
import { YearService } from '../../year/year.service';
import { AttendancePreferences } from '../attendance-preferences.model';
import { BehaviorPreferences } from '../behavior-preferences.model';
import { ClassRosterPreferences } from '../class-roster-preferences.model';
import { ClassesByCoursePreferences } from '../classes-by-course-preferences.model';
import { ClassroomSummaryPreferences } from '../classroom-summary-preferences.model';
import { CommunicationLogPreferences } from '../communication-log-preferences.model';
import { DataQueryPreferences } from '../data-query-preferences.model';
import { FavoritePreferences } from '../favorite-prefences.model';
import { GeneralPreferences } from '../general-preferences.model';
import { MassEmailPreferences } from '../mass-email-preferences.model';
import { MasterSchedulePreferences } from '../master-schedule-preferences.model';
import { MyReportsPreferences } from '../my-reports-preferences.model';
import { PeriodStatisticsPreferences } from '../period-statistics-preferences.model';
import { RoomSchedulingSettingsPreferences } from '../room-scheduling-settings-preferences.model';
import { ScheduleStudentListPreferences } from '../schedule-student-list-preferences.model';
import { UserPreferencesService } from '../user-preferences.service';
import { AdditionalTeacherWarningDialogComponent } from './additional-teacher-warning-dialog/additional-teacher-warning-dialog.component';
import { CalculationPreferenceWarningDialogComponent } from './calculation-preference-warning-dialog/calculation-preference-warning-dialog.component';
import { CustomSortWarningDialogComponent } from './custom-sort-warning-dialog/custom-sort-warning-dialog.component';
import { GradebookPreferencesResetWarningsComponent } from './gradebook-preferences-reset-warnings/gradebook-preferences-reset-warnings.component';
import { NoGradingClassesDialogComponent } from './no-grading-classes-dialog/no-grading-classes-dialog.component';
import { PrimaryTeacherWarningDialogComponent } from './primary-teacher-warning-dialog/primary-teacher-warning-dialog.component';
import { ProjectScoresInfoComponent } from './project-scores-info/project-scores-info.component';
import { SyncPreferencesDialogComponent } from './sync-preferences-dialog/sync-preferences-dialog.component';

@Component({
    selector: 'user-preferences-window',
    templateUrl: './user-preferences-window.component.html',
    styleUrls: ['./user-preferences-window.component.css']
})
export class UserPreferencesWindowComponent implements OnInit, AfterViewInit {

    @Input() staffAssignedPortals: Portal[];
    @Input() courseId: number;
    @ViewChild('specialMarks') specialMarks: ElementRef;
    @ViewChild('scoreValue') scoreValue: ElementRef;
    @ViewChild('gradebookPreferencesDiv') gradebookPreferencesDiv: ElementRef;
    @ViewChild('columnsInScoreGridRow') columnsInScoreGridRow: ElementRef;
    public entryId: number;
    public form: FormGroup;
    private saveRequests: Observable<any>[] = [];

    subscriptions: Subscription[] = [];
    // ------------User Data---------------------------
    staffAssignedPortalNames: boolean[] = [];
    generalPreferences: GeneralPreferences = new GeneralPreferences();
    sendingEmailAddress: any;
    currentYearSchools: School[];
    years: Year[];
    selectedYear: Year;
    attendancePreferences: AttendancePreferences;
    communicationLogPreferences: CommunicationLogPreferences;
    classroomSummaryPreferences: ClassroomSummaryPreferences = new ClassroomSummaryPreferences();
    dataQueryPreferences: DataQueryPreferences;
    massEmailPreferences: MassEmailPreferences;
    gradebookPreferences: GradebookPreferences = new GradebookPreferences();
    schoolYearSettings: any;
    favoritesPreferences: FavoritePreferences;
    behaviorPreferences: BehaviorPreferences;
    userPermissions: UserPermission[];
    @ViewChild('appFavorites', { static: true }) appFavorites: FavoritesComponent;
    schools: School[] = [];
    layouts: CustomLayout[] = [];
    // schoolLayouts: SchoolLayout[] = [];
    allLayoutsId = 0;
    defaultSchoolLayouts: CustomLayoutSchoolDefault[] = [];
    defaultUserLayoutId: number;
    numericZero = 0;
    masterSchedulePreferences: MasterSchedulePreferences;
    periodStatisticsPreferences: PeriodStatisticsPreferences;
    scheduleStudentListPreferences: ScheduleStudentListPreferences;
    classesByCoursePreferences: ClassesByCoursePreferences;
    classRosterPreferences: ClassRosterPreferences;
    roomSchedulingSettingsPreferences: RoomSchedulingSettingsPreferences;
    errors: ErrorList[] = [];
    // ------------Gradebook-----------------------------------
    selectedGradebookClass: ClassroomSummary;
    selectedGradebookClassId: any;
    myClasses: ClassroomSummary[] = [];
    additionalCourses: ClassroomSummary[] = [];
    gradebookSpecialMarks: SpecialMark[] = [];
    singleAdditional: boolean;
    multipleAdditional: boolean;
    additionalTeacher: boolean;
    additionalTeacherClassFocus: boolean;
    userSchoolYearPolicies: UserSchoolYearPolicies;
    setDefaultForStandardsView: boolean;
    warnIfCalculationPreferencesChanged: boolean;

    // ------------Selection/Flags-----------------------------------
    activateClassroom360: boolean;
    userIsTeacher: boolean;
    selectedPreferenceTab: string;
    v10: boolean;
    rowDetailExpand: boolean[] = [];
    useUnifiedLoginPage: boolean;
    classroom360AttendanceCommentsEditable: boolean;
    isDefaultPreferences = false;
    c360ShowCommunicationLog: boolean;
    viewAllStaffCommunicationLogs: boolean;
    disciplineQuickEntryUserCreateLayout: boolean;
    disciplineQuickEntrySetDefaultSchoolLayout: boolean;
    disciplineQuickEntrySetDefaultDistrictLayout: boolean;
    disciplineQuickEntryUserSelectLayout: boolean;
    allowDisciplineQuickEntry: boolean;
    activateAttendanceAdministration = false;

    currentUser: User;
    gradebookStudentSortOrderOptions: string[] = ['Course Add Date', 'Custom', 'Status', 'Student Name'];
    // ------------Modal windows----------------------------------
    additionalTeacherWarningDialogRef: MatDialogRef<AdditionalTeacherWarningDialogComponent>;
    calculationPreferenceWarningDialogRef: MatDialogRef<CalculationPreferenceWarningDialogComponent>;
    customSortWarningDialogRef: MatDialogRef<CustomSortWarningDialogComponent>;
    noGradingClassesDialogRef: MatDialogRef<NoGradingClassesDialogComponent>;
    primaryTeacherWarningDialogRef: MatDialogRef<PrimaryTeacherWarningDialogComponent>;
    syncPrefDialogRef: MatDialogRef<SyncPreferencesDialogComponent>;
    projectScoresDialog: MatDialogRef<ProjectScoresInfoComponent>;
    staffAssignedPortalsCopy: Portal[] = [];

    // -------------------- MY Reports ----------------------------
    myReportsPreferences: MyReportsPreferences;

    constructor(
        private dialogRef: MatDialogRef<UserPreferencesWindowComponent>,
        private userService: UserService,
        private yearService: YearService,
        private loginService: LoginService,
        private userPreferenceService: UserPreferencesService,
        private router: Router,
        private dialog: MatDialog,
        private customLayoutService: CustomLayoutsService,
        private classroom360Service: Classroom360Service,
        private gradebookV9Service: GradebookV9Service,
        private sharedService: SharedService,
        private securityService: SecurityService,
        @Inject(MAT_DIALOG_DATA) private data: any
    ) {
        this.form = new FormGroup({
            filler: new FormControl()
        });

        this.activateClassroom360 = loginService.LoginSettings.ActivateClassroom360;
        this.currentUser = this.userService.currentUser;
        this.userIsTeacher = userService.currentUser.UserIsTeacher;
        this.v10 = loginService.LoginSettings.V10;
        this.useUnifiedLoginPage = loginService.LoginSettings.UseUnifiedLoginPage;
        this.c360ShowCommunicationLog = loginService.LoginSettings.C360ShowCommunicationLog;
        this.classroom360AttendanceCommentsEditable = loginService.LoginSettings.Classroom360AttendanceCommentsEditable;
        this.activateAttendanceAdministration = loginService.LoginSettings.ActivateAttendanceAdministration360;
        this.dataQueryPreferences = new DataQueryPreferences;

        if (this.data == null || this.data.initialTab == undefined || this.data.initialTab == null) {
            this.selectedPreferenceTab = 'General';
        } else {
            this.selectedPreferenceTab = this.data.initialTab;
            if (!this.v10 && this.selectedPreferenceTab == 'Gradebook') {
                if (this.activateClassroom360 && !this.userIsTeacher || this.data.isDefaultPreferences) {
                    this.selectedPreferenceTab = 'General';
                }
            }
        }

        if (this.data != null && this.data.isDefaultPreferences != undefined) {
            this.isDefaultPreferences = this.data.isDefaultPreferences;
        }

        this.getMyClass();
        this.getUserSchoolYearPolicies();
        this.getUserPermission();
        this.getSchoolYearSettings();

        this.getGeneralPreferences();
        this.getDataQueryPreferences();
        this.getAttendancePreferences();
        this.getClassroomSummaryPreferences();
        this.getCommunicationLogPreferences();
        this.getMassEmailPreferences();
        this.getMasterSchedulePreferences();
        this.getPeriodStatisticsPreferences();
        this.getScheduleStudentListPreferences();
        this.getClassesByCoursePreferences();
        this.getClassRosterPreferences();
        this.getRoomSchedulingSettingsPreferences();
        this.getMyReportsPreferences();
    }

    // --------------LifeCycle---------------------------------------

    ngOnInit() {
        //  relies on @input that is not available until ngOnInit
        this.getStaffAssignedPortals();
        //  requires getStaffAssignedPortals
        //  this.getFavoritesPreferences();
        //  relies on data
        if (this.data && this.data.selectedTab) {
            this.selectedPreferenceTab = this.data.selectedTab;
        }
    }

    ngAfterViewInit() {
        if (this.data.scrollToElement != null && this.data.scrollToElement != '') {
            if (this.data.scrollToElement == 'COLUMNS IN SCORES GRID' && this.gradebookPreferencesDiv != null && this.columnsInScoreGridRow != null) {
                this.gradebookPreferencesDiv.nativeElement.scrollTop = this.columnsInScoreGridRow.nativeElement.offsetTop;
            }
        }
    }

    columnDropped(event) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
        }
        this.setGradebookStudentNumberColumn();
    }

    columnDroppedAndSort(event, column: string) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex);
            // //if transfer, recalculate the order of previous (the list from drag)
            // if(column) {
            //     event.previousContainer.data.sort((a, b) => a[column] < b[column] ? -1 : a[column] > b[column] ? 1 : 0)
            //     event.previousContainer.data.forEach((x, index) => {
            //         x.order = index;
            //     });
            // }
            // else {
            //     event.previousContainer.data.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
            // }
        }
        // always, recalculate the order of the container (the list to drag)
        if (column) {
            event.container.data.sort((a, b) => a[column] < b[column] ? -1 : a[column] > b[column] ? 1 : 0);
            event.container.data.forEach((x, index) => {
                x.order = index;
            });
        } else {
            event.container.data.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
        }
        this.setGradebookStudentNumberColumn();
    }

    setGradebookStudentNumberColumn() {
        if (this.generalPreferences.ShowStudentNumber) {
            let studentNameColumn = this.gradebookPreferences.AvailableColumns.filter(c => c.Field == 'StudentName' || c.Field == 'StudentNumber')[0];
            if (studentNameColumn != undefined) {
                this.gradebookPreferences.AvailableColumns = this.gradebookPreferences.AvailableColumns.filter(c => c.Field != 'StudentName');
                this.gradebookPreferences.AvailableColumns = this.gradebookPreferences.AvailableColumns.filter(c => c.Field != 'StudentNumber');
            } else {
                studentNameColumn = this.gradebookPreferences.ScrollingColumns.filter(c => c.Field == 'StudentName' || c.Field == 'StudentNumber')[0];
                if (studentNameColumn != undefined) {
                    this.gradebookPreferences.ScrollingColumns = this.gradebookPreferences.ScrollingColumns.filter(c => c.Field != 'StudentName');
                    this.gradebookPreferences.ScrollingColumns = this.gradebookPreferences.ScrollingColumns.filter(c => c.Field != 'StudentNumber');
                }
            }
            if (studentNameColumn != undefined) {
                this.gradebookPreferences.NonScrollingColumns.unshift(studentNameColumn);
            }
            studentNameColumn = this.gradebookPreferences.NonScrollingColumns.filter(c => c.Field == 'StudentName' || c.Field == 'StudentNumber')[0];
            this.gradebookPreferences.NonScrollingColumns.unshift(this.gradebookPreferences.NonScrollingColumns.splice(this.gradebookPreferences.NonScrollingColumns.indexOf(studentNameColumn), 1)[0]);
        }
    }

    // ------------Get User Data---------------------------

    getStaffAssignedPortals() {

        // Helper Function
        const processStaffAssignedPortals = () => {
            for (let i = 0; i < this.staffAssignedPortals.length; i++) {
                if (this.staffAssignedPortals[i].Deleted == false) {
                    if (this.staffAssignedPortals[i].PortalName != 'Attendance' || this.staffAssignedPortals[i].PortalDescription == '/classroomAttendance') {
                        this.staffAssignedPortalNames[this.staffAssignedPortals[i].PortalName] = true;
                    }
                }
            }
        };

        // Performing Processing
        this.staffAssignedPortalNames = [];
        if (this.userService.userType == 1) {
            this.staffAssignedPortalNames['Classroom Summary'] = true;
            this.staffAssignedPortalNames['Mass Email'] = true;
        }
        if (!this.staffAssignedPortals) {
            this.staffAssignedPortals = this.classroom360Service.staffAssignedPortals;
            processStaffAssignedPortals();
        } else {
            this.subscriptions.push(
                this.classroom360Service.getStaffAssignedPortals().subscribe(result => {
                    this.staffAssignedPortals = result;
                    processStaffAssignedPortals();
                })
            );
        }
    }

    getUserPermission() {
        this.viewAllStaffCommunicationLogs = false;

        this.userPermissions = this.securityService.userPermissions;

        if (this.loginService.LoginSettings.C360ShowCommunicationLog == false) {
            if (this.userPermissions.filter(x => x.PermissionName == 'View ALL Staff Parent Contact Logs').length > 0) {
                this.viewAllStaffCommunicationLogs = true;
            }
        } else {
            if (this.userPermissions.filter(x => x.PermissionName == 'View All Communication Logs').length > 0) {
                this.viewAllStaffCommunicationLogs = true;
            } else if (this.userPermissions.filter(x => x.PermissionName == 'Add Edit All Communication Logs').length > 0) {
                this.viewAllStaffCommunicationLogs = true;
            }
        }
        if (this.v10) {
            this.allowDisciplineQuickEntry = this.userPermissions.filter(x => x.PrivilegeId == 2204).length > 0;
            this.disciplineQuickEntryUserSelectLayout = this.userPermissions.filter(x => x.PrivilegeId == 2543).length > 0;
            this.disciplineQuickEntryUserCreateLayout = this.userPermissions.filter(x => x.PrivilegeId == 2544).length > 0;
            this.disciplineQuickEntrySetDefaultSchoolLayout = this.userPermissions.filter(x => x.PrivilegeId == 2545).length > 0;
            this.disciplineQuickEntrySetDefaultDistrictLayout = this.userPermissions.filter(x => x.PrivilegeId == 2546).length > 0;
        } else {
            this.allowDisciplineQuickEntry = this.userPermissions.filter(x => x.PermissionName == 'Allow user to use Quick Entry').length > 0;
            this.disciplineQuickEntryUserSelectLayout = this.userPermissions.filter(x => x.PermissionName == 'Allow user to select own Quick Entry layout').length > 0;
            this.disciplineQuickEntryUserCreateLayout = this.userPermissions.filter(x => x.PermissionName == 'Allow user to create Quick Entry layout').length > 0;
            this.disciplineQuickEntrySetDefaultSchoolLayout = this.userPermissions.filter(x => x.PermissionName == 'User can set default Quick Entry layout for school').length > 0;
            this.disciplineQuickEntrySetDefaultDistrictLayout = this.userPermissions.filter(x => x.PermissionName == 'User can set default Quick Entry layout for district').length > 0;
        }
        if (this.isDefaultPreferences || (this.disciplineQuickEntryUserSelectLayout && this.allowDisciplineQuickEntry)) {
            this.getLayoutType();
        }
    }

    getMyClass() {
        const selectedTermId = 0; //  All terms
        const selectedViewValue = 3; //  Merged For Grading

        this.userPreferenceService.getMyClasses(selectedTermId, Number(selectedViewValue), this.userService.currentUser.UserIsTeacher, false, this.loginService.LoginSettings.V10 ? null : new Date(Date.now())).subscribe(data => {
            this.myClasses = data.filter(x => x.UsedForGrading && !x.AdditionalTeacher);
            this.additionalCourses = data.filter(x => x.UsedForGrading && x.AdditionalTeacher);
            this.getGradebookPreferences();
        });
    }

    setEmailAddress() {
        this.sendingEmailAddress = [
            { id: 'Personal', value: 'My Email Address' },
            { id: 'No Reply', value: 'Parent Notification Default "From" Address' }];

        if (this.v10) {
            this.sendingEmailAddress[1].value = 'System\'s No-Reply Email Address';
        }
    }

    getUserSchoolYear() {
        let year: any;
        this.years = [];

        // V10
        if (this.v10) {
            year = { Id: 'Current Year', Description: 'Current Year', AYIdentifier: 'Current Year' };
            this.years.push(year);

            for (year of this.yearService.allYears) {
                if (this.years.filter(y => y.AYIdentifier == year.AYIdentifier).length == 0) {
                    this.years.push(year);
                }
            }

            const selectedYear = this.years.filter(y => y.AYIdentifier == this.generalPreferences.DefaultYearIdentifier)[0];
            this.selectedYear = selectedYear;
            this.getCurrentYearSchools(selectedYear);
        }

        // V9
        if (!this.v10) {
            for (year of this.yearService.years) {
                if (this.years.filter(x => x.Description == year.Description).length == 0) {
                    this.years.push(year);
                }
            }
            this.getCurrentYearSchoolsV9(this.generalPreferences.DefaultYearIdentifier);
        }

    }

    getCurrentYearSchools(year: Year) {
        this.generalPreferences.DefaultYearIdentifier = (year) ? year.AYIdentifier : '';
        const yearDescription = (year) ? year.Description : '';
        this.currentYearSchools = [];
        let filterSchools: Year[] = [];

        let school: School = new School();
        school.Id = 0;
        school.SchoolName = '';
        this.currentYearSchools.push(school);

        if (yearDescription == 'Current Year') {
            const currentYear = this.yearService.allYears.find(x => x.Status == 1);
            if (currentYear) {
                filterSchools = this.yearService.allYears.filter(y => y.AYIdentifier == currentYear.AYIdentifier);
            }
        } else {
            filterSchools = (year) ? this.yearService.allYears.filter(y => y.AYIdentifier == year.AYIdentifier) : [];
        }

        if (filterSchools.length > 0) {
            for (let i = 0; i < filterSchools.length; i++) {
                school = new School();
                school.Id = filterSchools[i].SchoolID;
                school.SchoolName = filterSchools[i].SchoolName;
                this.currentYearSchools.push(school);
            }
        }
    }

    getCurrentYearSchoolsV9(yearDescription) {
        let school: School = new School();
        this.currentYearSchools = [];
        let filterSchools: Year[] = [];
        if (yearDescription == 'Current Year') {
            const currentYear = this.yearService.years.find(x => x.Status == 1);
            if (currentYear) {
                filterSchools = this.yearService.years.filter(x => x.Description == currentYear.Description);
            }
        } else {
            if (this.yearService.allYears.filter(x => x.SchoolID == 0).length > 0) {
                filterSchools = this.yearService.yearsForC360.filter(x => x.Id == parseInt(yearDescription, 10));
            } else {
                filterSchools = this.yearService.allYears.filter(x => x.Id == parseInt(yearDescription, 10));
            }
        }

        if (filterSchools.length > 0) {
            for (let i = 0; i < filterSchools.length; i++) {
                school = new School();

                school.Id = filterSchools[i].SchoolID;
                school.SchoolName = filterSchools[i].SchoolName;
                this.currentYearSchools.push(school);
            }
        }
    }

    getUserSchoolYearPolicies() {
        this.userService.getUserSchoolYearPolicies(this.yearService.defaultYear.Id, this.yearService.defaultYear.SchoolID).subscribe(data => {
            this.userSchoolYearPolicies = data;
        });
    }

    getSchoolYearSettings() {
        this.schoolYearSettings = {};
        if (this.loginService.LoginSettings.V10 == false) {
            this.yearService.getSchoolYearSettings(this.yearService.defaultYear.Id, this.yearService.defaultYear.SchoolID).subscribe(data => {
                this.schoolYearSettings = data;
            });
        }
    }

    // ------------Get Preference Data---------------------------

    getGeneralPreferences() {
        if (this.userPreferenceService.generalPreferences == undefined || this.isDefaultPreferences) {

            this.userPreferenceService.getUserPreferences(0, '/OneSISGeneralPreferences', 0, '', this.isDefaultPreferences).subscribe(data => {
                this.generalPreferences = JSON.parse(data);
                this.setEmailAddress();
                this.getUserSchoolYear();
                if (this.generalPreferences.PageSize == '0') {
                    this.generalPreferences.PageSize = '100';
                }
            });
        } else {
            this.generalPreferences = JSON.parse(JSON.stringify(this.userPreferenceService.generalPreferences));
            this.setEmailAddress();
            this.getUserSchoolYear();
            if (this.generalPreferences.PageSize == '0') {
                this.generalPreferences.PageSize = '100';
            }
        }
    }

    getAttendancePreferences() {
        if (this.userPreferenceService.attendancePreferences == undefined || this.isDefaultPreferences) {
            this.userPreferenceService.getUserPreferences(0, '/OneSISAttendance', 0, '', this.isDefaultPreferences).subscribe(data => {
                this.attendancePreferences = JSON.parse(data);
                this.attendancePreferences.ShowAlert = this.yearService.defaultYear.DisplayStudentAlertsOnAttendance;
                if (!this.isDefaultPreferences) {
                    this.userPreferenceService.attendancePreferences = JSON.parse(JSON.stringify(this.attendancePreferences));
                }
            });
        } else {
            this.attendancePreferences = JSON.parse(JSON.stringify(this.userPreferenceService.attendancePreferences));
            this.attendancePreferences.ShowAlert = this.yearService.defaultYear.DisplayStudentAlertsOnAttendance;
        }
    }

    getBehaviorPreferences() {
        if (this.userPreferenceService.behaviorPreferences == undefined || this.isDefaultPreferences) {
            this.userPreferenceService.getUserPreferences(0, '/OneSISBehavior', 0, '', this.isDefaultPreferences).subscribe(data => {
                if (data != null && data != '') {
                    this.behaviorPreferences = JSON.parse(data);
                    if (!this.isDefaultPreferences) {
                        this.userPreferenceService.behaviorPreferences = JSON.parse(JSON.stringify(this.behaviorPreferences));
                    }
                    this.defaultUserLayoutId = this.behaviorPreferences.Layout_ID;
                }
                else {
                    this.behaviorPreferences = new BehaviorPreferences();
                }
            });
        } else {
            this.behaviorPreferences = JSON.parse(JSON.stringify(this.userPreferenceService.behaviorPreferences));
            this.defaultUserLayoutId = this.behaviorPreferences.Layout_ID;
        }
    }


    getClassroomSummaryPreferences() {
        if (this.userPreferenceService.classroomSummaryPreferences == undefined || this.isDefaultPreferences) {
            this.userPreferenceService.getUserPreferences(0, '/OneSISClassroomSummary', 0, '', this.isDefaultPreferences).subscribe(results => {
                this.classroomSummaryPreferences = JSON.parse(results[0]);
                if (!this.isDefaultPreferences) {
                    this.userPreferenceService.classroomSummaryPreferences = JSON.parse(JSON.stringify(this.classroomSummaryPreferences));
                }
            });
        } else {
            this.classroomSummaryPreferences = JSON.parse(JSON.stringify(this.userPreferenceService.classroomSummaryPreferences));
        }
    }

    getCommunicationLogPreferences() {
        if (this.userPreferenceService.communicationLogPreferences == undefined || this.isDefaultPreferences) {
            this.userPreferenceService.getUserPreferences(0, '/OneSISCommunicationLog', 0, '', this.isDefaultPreferences).subscribe(results => {
                this.communicationLogPreferences = JSON.parse(results[0]);
                if (!this.isDefaultPreferences) {
                    this.userPreferenceService.communicationLogPreferences = JSON.parse(JSON.stringify(this.communicationLogPreferences));
                }
            });
        } else {
            this.communicationLogPreferences = JSON.parse(JSON.stringify(this.userPreferenceService.communicationLogPreferences));
        }
    }

    getDataQueryPreferences() {
        if (this.userPreferenceService.dataQueryPreferences == undefined || this.isDefaultPreferences) {
            this.userPreferenceService.getUserPreferences(0, '/OneSISDataQuery', 0, '', this.isDefaultPreferences).subscribe(results => {
                this.dataQueryPreferences = JSON.parse(results[0]);
                if (!this.isDefaultPreferences) {
                    this.userPreferenceService.dataQueryPreferences = JSON.parse(JSON.stringify(this.dataQueryPreferences));
                }
            });
        } else {
            this.dataQueryPreferences = JSON.parse(JSON.stringify(this.userPreferenceService.dataQueryPreferences));
        }
    }

    getFavoritesPreferences() {
        if (this.userPreferenceService.favoritesPreferences == undefined || this.isDefaultPreferences) {
            this.userPreferenceService.getUserPreferences(0, '/OneSISFavorites', 0, '', this.isDefaultPreferences).subscribe(results => {
                this.favoritesPreferences = JSON.parse(results[0]);

                for (let i = 0; i < this.favoritesPreferences.FavoritePortals.length; i++) {
                    const portalIndex: number = this.staffAssignedPortals.findIndex(x => x.PortalDescription == this.favoritesPreferences.FavoritePortals[i].PortalDescription);

                    if (portalIndex != -1) {
                        this.staffAssignedPortals[portalIndex].Selected = true;
                    }
                }
                if (!this.isDefaultPreferences) {
                    this.userPreferenceService.favoritesPreferences = JSON.parse(JSON.stringify(this.favoritesPreferences));
                }
            });

        } else {
            this.favoritesPreferences = JSON.parse(JSON.stringify(this.userPreferenceService.favoritesPreferences));

            for (let i = 0; i < this.favoritesPreferences.FavoritePortals.length; i++) {
                const portalIndex: number = this.staffAssignedPortals.findIndex(x => x.PortalDescription == this.favoritesPreferences.FavoritePortals[i].PortalDescription);

                if (portalIndex != -1) {
                    this.staffAssignedPortals[portalIndex].Selected = true;
                }
            }
        }
    }

    getMassEmailPreferences() {
        if (this.userPreferenceService.massEmailPreferences == undefined || this.userPreferenceService.massEmailPreferences.Signature == undefined || this.isDefaultPreferences) {
            this.userPreferenceService.getUserPreferences(0, '/OneSISMassEmail', 0, '', this.isDefaultPreferences).subscribe(results => {
                this.massEmailPreferences = JSON.parse(results[0]);
                if (!this.isDefaultPreferences) {
                    this.userPreferenceService.massEmailPreferences = JSON.parse(JSON.stringify(this.massEmailPreferences));
                }
            });
        } else {
            this.massEmailPreferences = JSON.parse(JSON.stringify(this.userPreferenceService.massEmailPreferences));
        }
    }

    getGradebookPreferences() {
        if (this.selectedGradebookClass == undefined) {
            if (this.myClasses.length > 0) {
                this.selectedGradebookClass = this.myClasses.filter(x => x.Id == this.courseId)[0];
                if (this.selectedGradebookClass == undefined) {
                    this.selectedGradebookClass = this.myClasses[0];
                }
            }
            else {
                this.selectedGradebookClass = this.additionalCourses.filter(x => x.Id == this.courseId)[0];
                if (this.selectedGradebookClass == undefined) {
                    this.selectedGradebookClass = this.additionalCourses[0];
                }
            }
        }
        if (this.gradebookPreferences == undefined || !this.gradebookPreferences.SyncPreferencesAcrossCourses || this.v10 || this.isDefaultPreferences) {
            let subjectListId = 0;
            let subjectSection = '';
            if (!this.v10) {
                if (this.selectedGradebookClass != undefined && this.selectedGradebookClass.SiteSubjectListId != undefined) {
                    subjectListId = this.selectedGradebookClass.SiteSubjectListId;
                    subjectSection = this.selectedGradebookClass.Section;
                }

                this.userPreferenceService.getUserPreferences(0, '/OneSISGradeBook', subjectListId, subjectSection, this.isDefaultPreferences).subscribe(results => {
                    this.gradebookPreferences = JSON.parse(results[0]);
                    if (!this.isDefaultPreferences) {
                        this.userPreferenceService.gradebookPreferences = JSON.parse(JSON.stringify(this.gradebookPreferences));
                        if (parseInt(this.gradebookPreferences.AutoSaveDuration, 10) < 0) {
                            this.gradebookPreferences.AutoSaveDuration = '0';
                        }
                        if (this.gradebookPreferences != undefined && this.gradebookPreferences.DefaultForStandardsView == 'Show') {
                            this.setDefaultForStandardsView = true;
                        } else {
                            this.setDefaultForStandardsView = false;
                        }
                        if (this.gradebookPreferences && this.gradebookPreferences.StudentSortOrder == 'Custom') {
                            this.gradebookStudentSortOrderOptions = ['Course Add Date', 'Custom (Set custom order from Tools menu)', 'Status', 'StudentName'];
                        } else {
                            this.gradebookStudentSortOrderOptions = ['Course Add Date', 'Custom', 'Status', 'StudentName'];
                        }
                    }
                    this.changeFillBlankScore();
                    if (this.gradebookPreferences.ResetPreferences == true) {
                        this.getGradebookPreferencesResetWarningWindow();
                    }
                });
            } else {
                if (this.selectedGradebookClass != undefined) {
                    subjectListId = this.selectedGradebookClass.Id;
                    this.userPreferenceService.getUserPreferences(0, '/OneSISGradeBook', subjectListId, subjectSection, this.isDefaultPreferences).subscribe(data => {
                        this.gradebookPreferences = JSON.parse(data);

                        if (this.userSchoolYearPolicies.ShowInactiveStudents) {
                            this.gradebookPreferences.ShowDroppedWithdrawn = true;
                        }
                        if (this.userSchoolYearPolicies.DisableAutoSave) {
                            this.gradebookPreferences.AutoSave = false;
                        }
                        if (!this.userSchoolYearPolicies.AllowQuickAddAssignments) {
                            this.gradebookPreferences.UseQuickAddWindow = false;
                        }
                        if (this.userSchoolYearPolicies.DefaultParentPublish) {
                            this.gradebookPreferences.DefaultShowOnPortal = true;
                        }

                        if (this.additionalCourses != undefined && this.additionalCourses.length > 0) {
                            if (this.additionalCourses.length == 1) {
                                this.singleAdditional = true;
                            } else {
                                this.multipleAdditional = true;
                            }
                            this.additionalTeacher = true;
                            if (this.router.url == 'classroom360/gradebook/V10') {
                                const gradebookClass = this.additionalCourses.filter(function (element) {
                                    return element.Id == this.userPreferenceService.courseId;
                                })[0];
                                if (gradebookClass != undefined && !this.gradebookPreferences.SyncPreferencesAcrossCourses) {
                                    this.additionalTeacherClassFocus = (gradebookClass.AdditionalTeacher) ? true : false;
                                }
                            }
                        }

                        if (!this.userSchoolYearPolicies.IsAllowTeacherToSetFinalGradeCalculation) {
                            this.gradebookPreferences.FGradeCalculationType = this.userSchoolYearPolicies.FGradeCalculationType.toString();
                            // Set Calculation Type Preferences From Policies
                            if (this.gradebookPreferences.FGradeCalculationType == '1') {
                                this.gradebookPreferences.SemesterFinalGradeCalculationPoints = '0';
                                this.gradebookPreferences.SemesterFinalGradeCalculationCombo = '0';
                            } else if (this.gradebookPreferences.FGradeCalculationType == '2') {
                                this.gradebookPreferences.SemesterFinalGradeCalculationPoints = this.userSchoolYearPolicies.SemesterFinalGradeCalculation.toString();
                                this.gradebookPreferences.SemesterFinalGradeCalculationCombo = '0';
                            } else if (this.gradebookPreferences.FGradeCalculationType == '3') {
                                this.gradebookPreferences.SemesterFinalGradeCalculationPoints = '0';
                                this.gradebookPreferences.SemesterFinalGradeCalculationCombo = this.userSchoolYearPolicies.SemesterFinalGradeCalculation.toString();
                            }
                        }

                        // Set Rounding Preferences From Policies
                        if (!this.userSchoolYearPolicies.IsAllowTeacherToSelectAssignmentRoundingInGB) {
                            this.gradebookPreferences.NumericalGradeRoundTo = this.userSchoolYearPolicies.NumericalGradeRoundTo.toString();
                        }

                        if (!this.userSchoolYearPolicies.IsAllowTeacherToSelectGPRoundingInGB) {
                            if (this.userSchoolYearPolicies.IsGPCWRoundDown) {
                                this.gradebookPreferences.GPCWRound = '1';
                            } else if (this.userSchoolYearPolicies.IsGPCWRoundUp) {
                                this.gradebookPreferences.GPCWRound = '2';
                            } else {
                                this.gradebookPreferences.GPCWRound = '3';
                            }
                            this.gradebookPreferences.GPCWRoundToValue = this.userSchoolYearPolicies.GPCWRoundToValue.toString();
                        }
                        if (!this.userSchoolYearPolicies.IsAllowTeacherToSelectSemRoundingInGB) {
                            if (this.userSchoolYearPolicies.IsSemFinalRoundDown) {
                                this.gradebookPreferences.SemFinalRound = '1';
                            } else if (this.userSchoolYearPolicies.IsSemFinalRoundUp) {
                                this.gradebookPreferences.SemFinalRound = '2';
                            } else {
                                this.gradebookPreferences.SemFinalRound = '3';
                            }
                            this.gradebookPreferences.SemFinalRoundToValue = this.userSchoolYearPolicies.SemFinalRoundToValue.toString();
                        }

                        this.userPreferenceService.gradebookPreferences = JSON.parse(JSON.stringify(this.gradebookPreferences));

                        //  Wait until gradebook preferences have loaded
                        if (this.router.url == '/classroom360/gradebook/V10') {
                            this.menuSelected('Gradebook');
                        }

                        this.userPreferenceService.getWarnIfCalculationPreferencesChanged(this.selectedGradebookClass.Id, this.gradebookPreferences.SyncPreferencesAcrossCourses).subscribe(result => {
                            this.warnIfCalculationPreferencesChanged = result;
                        });
                        this.changeFillBlankScore();
                    });
                } else {
                    if (this.additionalCourses != undefined && this.additionalCourses.length > 0) {
                        if (this.additionalCourses.length == 1) {
                            this.singleAdditional = true;
                        } else {
                            this.multipleAdditional = true;
                        }
                        this.additionalTeacher = true;
                        if (this.router.url == 'classroom360/gradebook/V10') {
                            const gradebookClass = this.additionalCourses.filter(function (element) {
                                return element.Id == this.userPreferenceService.courseId;
                            })[0];
                            if (gradebookClass != undefined && !this.gradebookPreferences.SyncPreferencesAcrossCourses) {
                                this.additionalTeacherClassFocus = (gradebookClass.AdditionalTeacher) ? true : false;
                            }
                        }
                    }
                }
            }
        } else {
            this.gradebookPreferences = JSON.parse(JSON.stringify(this.userPreferenceService.gradebookPreferences));
            if (this.additionalCourses != undefined && this.additionalCourses.length > 0) {
                if (this.additionalCourses.length == 1) {
                    this.singleAdditional = true;
                } else {
                    this.multipleAdditional = true;
                }
                this.additionalTeacher = true;
                if (this.router.url == 'classroom360/gradebook/V10') {
                    const gradebookClass = this.additionalCourses.filter(function (element) {
                        return element.Id == this.userPreferenceService.courseId;
                    })[0];
                    if (gradebookClass != undefined && !this.gradebookPreferences.SyncPreferencesAcrossCourses) {
                        this.additionalTeacherClassFocus = (gradebookClass.AdditionalTeacher) ? true : false;
                    }
                }
            }
            if (this.gradebookPreferences != undefined && this.gradebookPreferences.DefaultForStandardsView == 'Show') {
                this.setDefaultForStandardsView = true;
            } else {
                this.setDefaultForStandardsView = false;
            }
            this.changeFillBlankScore();
        }

        if (this.v10 == false && this.gradebookSpecialMarks.length == 0) {
            if (this.gradebookV9Service.specialMarks.length == 0) {
                this.gradebookV9Service.course = new ClassroomSummary();
                this.gradebookV9Service.course.Id = 0;
                this.gradebookV9Service.getGradebookV9SpecialMarks().subscribe(specialMarks => {
                    this.gradebookV9Service.specialMarks = specialMarks;
                    this.gradebookSpecialMarks = JSON.parse(JSON.stringify(this.gradebookV9Service.specialMarks.filter(o => o.Selected == true)));
                    const specialMark: SpecialMark = {
                        Id: 0,
                        Code: '',
                        Description: '',
                        Value: 0,
                        Operation: 0,
                        Locked: false,
                        Selected: true,
                        InUse: false,
                        IsSelected: false,
                        IsEdited: false,
                        OperationDescription: '',
                        IsUsedInCurrentYear: false,
                        ColorCode: ''
                    };
                    this.gradebookSpecialMarks.splice(0, 0, specialMark);
                });
            } else {
                this.gradebookSpecialMarks = JSON.parse(JSON.stringify(this.gradebookV9Service.specialMarks.filter(o => o.Selected == true)));
                const specialMark: SpecialMark = {
                    Id: 0,
                    Code: '',
                    Description: '',
                    Value: 0,
                    Operation: 0,
                    Locked: false,
                    Selected: true,
                    InUse: false,
                    IsSelected: false,
                    IsEdited: false,
                    OperationDescription: '',
                    IsUsedInCurrentYear: false,
                    ColorCode: ''
                };
                this.gradebookSpecialMarks.splice(0, 0, specialMark);
            }
        }
    }

    getGradebookPreferencesResetWarningWindow() {
        const gradebookPreferencesResetWarningsRef = this.dialog.open(GradebookPreferencesResetWarningsComponent, {
            panelClass: 'tyl-mat-dialog',
            width: '425px',
            disableClose: true
        });

        gradebookPreferencesResetWarningsRef.afterClosed().subscribe(returnMessage => {
            if (returnMessage == 'Preferences was clicked.') {
                this.selectedPreferenceTab = 'Gradebook';
                setTimeout(() => {
                    if (this.gradebookPreferencesDiv != null && this.columnsInScoreGridRow != null) {
                        this.gradebookPreferencesDiv.nativeElement.scrollTop = this.columnsInScoreGridRow.nativeElement.offsetTop;
                    }
                }, 100);
            }
        });
    }

    getMasterSchedulePreferences() {
        if (this.userPreferenceService.masterSchedulePreferences == undefined || this.isDefaultPreferences) {
            this.userPreferenceService.getUserPreferences(0, '/OneSISMasterSchedule', 0, '', this.isDefaultPreferences).subscribe(results => {
                this.masterSchedulePreferences = JSON.parse(results[0]);
                if (!this.isDefaultPreferences) {
                    this.userPreferenceService.masterSchedulePreferences = JSON.parse(JSON.stringify(this.masterSchedulePreferences));
                }
            });
        } else {
            this.masterSchedulePreferences = JSON.parse(JSON.stringify(this.userPreferenceService.masterSchedulePreferences));
        }
    }

    getPeriodStatisticsPreferences() {
        if (this.userPreferenceService.periodStatisticsPreferences == undefined || this.isDefaultPreferences) {
            this.userPreferenceService.getUserPreferences(0, '/OneSISPeriodStatistics', 0, '', this.isDefaultPreferences).subscribe(results => {
                this.periodStatisticsPreferences = JSON.parse(results[0]);
                if (!this.isDefaultPreferences) {
                    this.userPreferenceService.periodStatisticsPreferences = JSON.parse(JSON.stringify(this.periodStatisticsPreferences));
                }
            });
        } else {
            this.periodStatisticsPreferences = JSON.parse(JSON.stringify(this.userPreferenceService.periodStatisticsPreferences));
        }

    }

    getScheduleStudentListPreferences() {
        if (this.userPreferenceService.scheduleStudentListPreferences == undefined || this.isDefaultPreferences) {
            this.userPreferenceService.getUserPreferences(0, '/OneSISScheduleStudentList', 0, '', this.isDefaultPreferences).subscribe(results => {
                this.scheduleStudentListPreferences = JSON.parse(results[0]);
                if (!this.isDefaultPreferences) {
                    this.userPreferenceService.scheduleStudentListPreferences = JSON.parse(JSON.stringify(this.scheduleStudentListPreferences));
                }
            });
        } else {
            this.scheduleStudentListPreferences = JSON.parse(JSON.stringify(this.userPreferenceService.scheduleStudentListPreferences));
        }
    }

    getClassesByCoursePreferences() {
        if (this.userPreferenceService.classesByCoursePreferences == undefined || this.isDefaultPreferences) {
            this.userPreferenceService.getUserPreferences(0, '/OneSISClassesByCourse', 0, '', this.isDefaultPreferences).subscribe(results => {
                this.classesByCoursePreferences = JSON.parse(results[0]);
                if (!this.isDefaultPreferences) {
                    this.userPreferenceService.classesByCoursePreferences = JSON.parse(JSON.stringify(this.classesByCoursePreferences));
                }
            });
        } else {
            this.classesByCoursePreferences = JSON.parse(JSON.stringify(this.userPreferenceService.classesByCoursePreferences));
        }
    }

    getClassRosterPreferences() {
        if (this.userPreferenceService.classRosterPreferences == undefined || this.isDefaultPreferences) {
            this.userPreferenceService.getUserPreferences(0, '/OneSISClassRoster', 0, '', this.isDefaultPreferences).subscribe(results => {
                this.classRosterPreferences = JSON.parse(results[0]);
                if (!this.isDefaultPreferences) {
                    this.userPreferenceService.classRosterPreferences = JSON.parse(JSON.stringify(this.classRosterPreferences));
                }
            });
        } else {
            this.classRosterPreferences = JSON.parse(JSON.stringify(this.userPreferenceService.classRosterPreferences));
        }
    }

    getRoomSchedulingSettingsPreferences() {
        if (this.userPreferenceService.roomSchedulingSettingsPreferences == undefined || this.isDefaultPreferences) {
            this.userPreferenceService.getUserPreferences(0, '/OneSISRoomSchedulingSettings', 0, '', this.isDefaultPreferences).subscribe(results => {
                this.roomSchedulingSettingsPreferences = JSON.parse(results[0]);
                if (!this.isDefaultPreferences) {
                    this.userPreferenceService.roomSchedulingSettingsPreferences = JSON.parse(JSON.stringify(this.roomSchedulingSettingsPreferences));
                }
            });
        } else {
            this.roomSchedulingSettingsPreferences = JSON.parse(JSON.stringify(this.userPreferenceService.roomSchedulingSettingsPreferences));
        }
    }

    getMyReportsPreferences() {
        if (this.userPreferenceService.myReportsPreferences == undefined || this.isDefaultPreferences) {
            this.userPreferenceService.getUserPreferences(0, '/OneSISMyReports', 0, '', this.isDefaultPreferences).subscribe(results => {
                this.myReportsPreferences = JSON.parse(results[0]);
                if (!this.isDefaultPreferences) {
                    this.userPreferenceService.myReportsPreferences = JSON.parse(JSON.stringify(this.myReportsPreferences));
                }
            });
        } else {
            this.myReportsPreferences = JSON.parse(JSON.stringify(this.userPreferenceService.myReportsPreferences));
        }
    }

    // ------------Save Preference Data--------------------------
    saveClick() {
        this.errors = [];
        if (this.loginService.LoginSettings.ActivateClassroom360 == false) {
            if (!this.isDefaultPreferences) {
                this.userPreferenceService.generalPreferences = this.generalPreferences;
            }
            this.saveUserPreferences('/OneSISGeneralPreferences', this.generalPreferences, 0, '');
        } else if (this.loginService.LoginSettings.V10 == false && this.gradebookPreferences.FillBlankScores == 'Score'
            && this.gradebookPreferences.FillBlankScoreValue == null) {
            this.errors.push({
                fieldName: 'Score',
                fieldRef: this.scoreValue,
                errorMsg: 'Score is required'
            });
            this.menuSelected('Gradebook');
        } else if (this.loginService.LoginSettings.V10 == false && this.gradebookPreferences.FillBlankScores == 'SpecialMark'
            && (this.gradebookPreferences.FillBlankScoreSpecialMarkId == null || this.gradebookPreferences.FillBlankScoreSpecialMarkId == '0')) {
            this.errors.push({
                fieldName: 'Special Mark',
                fieldRef: this.specialMarks,
                errorMsg: 'Special Mark is required'
            });
            this.menuSelected('Gradebook');
        } else {
            if (this.gradebookPreferences != null && ((this.loginService.LoginSettings.V10
                // && _.findWhere(this.gradebookPreferences.AvailableColumns, { Field: 'Final' }))
                && (this.gradebookPreferences.AvailableColumns.filter(x => x.Field == 'Final').length > 0))
                || (!this.loginService.LoginSettings.V10 && this.gradebookPreferences.ReportCardGrades == 0))) {
                this.gradebookPreferences.ShowProgressCycles = false;
                this.gradebookPreferences.ShowTerms = false;
                this.gradebookPreferences.ShowSemesters = false;
                this.gradebookPreferences.ShowYearEnd = false;
                this.gradebookPreferences.ShowAllTerms = false;
            }
            if (!this.isDefaultPreferences) {
                this.userPreferenceService.generalPreferences = this.generalPreferences;
                this.userPreferenceService.attendancePreferences = this.attendancePreferences;
                this.userPreferenceService.classroomSummaryPreferences = this.classroomSummaryPreferences;
                this.userPreferenceService.communicationLogPreferences = this.communicationLogPreferences;
                this.userPreferenceService.dataQueryPreferences = this.dataQueryPreferences;
                this.userPreferenceService.massEmailPreferences = this.massEmailPreferences;
                this.userPreferenceService.gradebookPreferences = this.gradebookPreferences;
                this.userPreferenceService.favoritesPreferences = this.favoritesPreferences;
                this.userPreferenceService.masterSchedulePreferences = this.masterSchedulePreferences;
                this.userPreferenceService.periodStatisticsPreferences = this.periodStatisticsPreferences;
                this.userPreferenceService.scheduleStudentListPreferences = this.scheduleStudentListPreferences;
                this.userPreferenceService.classesByCoursePreferences = this.classesByCoursePreferences;
                this.userPreferenceService.classRosterPreferences = this.classRosterPreferences;
                this.userPreferenceService.roomSchedulingSettingsPreferences = this.roomSchedulingSettingsPreferences;
                this.userPreferenceService.myReportsPreferences = this.myReportsPreferences;
            }

            // this.setFavoritesPreferences();
            this.saveUserPreferences('/OneSISGeneralPreferences', this.generalPreferences, 0, '');
            if (this.loginService.LoginSettings.V10 && this.router.url == 'classroom360/gradebook/V10') {
                this.saveUserPreferences('/OneSISAttendance', this.attendancePreferences, 0, '');
            } else {
                this.saveUserPreferences('/OneSISAttendance', this.attendancePreferences, 0, '');
            }

            this.saveUserPreferences('/OneSISClassroomSummary', this.classroomSummaryPreferences, 0, '');
            this.saveUserPreferences('/OneSISCommunicationLog', this.communicationLogPreferences, 0, '');
            //  this.saveUserPreferences('/OneSISFavorites', this.favoritesPreferences, 0, '');
            this.appFavorites.save();
            this.saveUserPreferences('/OneSISMassEmail', this.massEmailPreferences, 0, '');
            this.saveUserPreferences('/OneSISDataQuery', this.dataQueryPreferences, 0, '');
            this.saveUserPreferences('/OneSISMasterSchedule', this.masterSchedulePreferences, 0, '');
            this.saveUserPreferences('/OneSISPeriodStatistics', this.periodStatisticsPreferences, 0, '');
            this.saveUserPreferences('/OneSISScheduleStudentList', this.scheduleStudentListPreferences, 0, '');
            this.saveUserPreferences('/OneSISClassesByCourse', this.classesByCoursePreferences, 0, '');
            this.saveUserPreferences('/OneSISClassRoster', this.classRosterPreferences, 0, '');
            this.saveUserPreferences('/OneSISRoomSchedulingSettings', this.roomSchedulingSettingsPreferences, 0, '');
            if (!this.loginService.LoginSettings.V10) {
                this.saveUserPreferences('/OneSISMyReports', this.myReportsPreferences, 0, '');
            }

            if (!this.loginService.LoginSettings.V10) {
                let subjectListId = 0;
                let subjectSection = '';
                if (this.selectedGradebookClass != undefined && this.selectedGradebookClass.SiteSubjectListId != undefined) {
                    subjectListId = this.selectedGradebookClass.SiteSubjectListId;
                    subjectSection = this.selectedGradebookClass.Section;
                }
                if (this.gradebookPreferences.SummaryCharacterCount == undefined || this.gradebookPreferences.SummaryCharacterCount.toString().length == 0 || isNaN(this.gradebookPreferences.SummaryCharacterCount)) {
                    this.gradebookPreferences.SummaryCharacterCount = 15;
                }
                if (this.gradebookPreferences.SummaryCharacterSlideCount == undefined || this.gradebookPreferences.SummaryCharacterSlideCount.toString().length == 0 || isNaN(this.gradebookPreferences.SummaryCharacterSlideCount)) {
                    this.gradebookPreferences.SummaryCharacterSlideCount = 40;
                }
                this.saveUserPreferences('/OneSISGradeBook', this.gradebookPreferences, subjectListId, subjectSection);
            } else {
                if (this.myClasses.length > 0 && (this.selectedGradebookClass != null || this.isDefaultPreferences)) {
                    const classId = (this.isDefaultPreferences) ? 0 : this.selectedGradebookClass.Id;
                    this.saveUserPreferences('/OneSISGradeBook', this.gradebookPreferences, classId, '');
                }
            }

            if (this.isDefaultPreferences) {
                this.saveBehaviorDefaultLayouts();
            } else if (this.disciplineQuickEntryUserSelectLayout && this.allowDisciplineQuickEntry) {
                this.saveUserDefaultLayout();
            }
        }


        // Saving the requests as batch and then closing
        const batchRequest = forkJoin(this.saveRequests);
        const saveSubscription = batchRequest.subscribe(() => {
            saveSubscription.unsubscribe();
            this.dialogRef.close('Save was clicked.');
        });
        // this.classroom360Service.getStaffAssignedPortals(0, true).subscribe(staffAssignedPortals => {
        //     this.classroom360Service.updateStaffAssignedPortals(staffAssignedPortals);
        // });
    }

    saveUserPreferences(pageUrl: string, preferenceData: any, subjectListId: number, subjectSection: string) {
        // PRE: the parameters needed to perform a preference save: pageUrl, the preferences, the subject list id, and the subject's section
        // POST: appends the save request to the list of save requests for batch saving
        const xmlStream: string[] = [];
        xmlStream.push(JSON.stringify(preferenceData));

        // Obtaining the save request
        const saveRequest = this.userPreferenceService.saveUserPreferences(0, pageUrl, xmlStream, subjectListId, subjectSection, this.isDefaultPreferences).pipe(
            map(result => {
                if (pageUrl == '/OneSISGradeBook') {
                    this.userPreferenceService.updateGradebookPReferences();
                }
                return result;
            })
        );

        // Appending it to our list of save requests
        this.saveRequests.push(saveRequest);
    }

    // ------------Helper Methods--------------------------

    editLayoutsClick() {
        // ONE-7723 Behavior Quick Add - Disable Edit My Layouts
        // We need to temporarily Disable the use of "Edit My Layout" in Preferences > Behavior.
        // Once the customization framework is built for v9 then we will enable it again.
        if (this.v10) {
            this.dialog.open(SavedLayoutsDialogComponent, { height: '80vh', minWidth: '1000px', disableClose: true });
            // if (this.customLayoutService.layoutTypes.length == 0) {
            //     this.subscriptions.push(this.customLayoutService.getLayoutTypes().subscribe(types => {
            //         this.customLayoutService.layoutTypes = types;
            //         this.customLayoutService.selectedLayoutType = types.find(t => t.Name == 'Behavior Quick Add');
            //         this.openLayoutEditor();
            //     }));
            // } else {
            //     this.customLayoutService.selectedLayoutType = this.customLayoutService.layoutTypes.find(t => t.Name == 'Behavior Quick Add');
            //     this.openLayoutEditor();
            // }
        }
    }

    openLayoutEditor() {
        // get default user layout before opening editor.
        this.subscriptions.push(this.customLayoutService.getUserDefaultLayout(this.customLayoutService.selectedLayoutType.Id, this.yearService.defaultYear.SchoolID, false).subscribe(layoutId => {
            this.customLayoutService.selectedLayout = this.layouts.find(o => o.Id == layoutId);
            const dialogRef = this.dialog.open(LayoutEditorComponent, {
                height: '100vh',
                width: '80vw',
                disableClose: true,
            });

            this.subscriptions.push(dialogRef.afterClosed().subscribe(result => {
                this.getBehaviorLayout();
            }));
        }));

    }

    getLayoutType() {
        if (this.customLayoutService.layoutTypes.length == 0) {
            this.subscriptions.push(this.customLayoutService.getLayoutTypes().subscribe(types => {
                this.customLayoutService.layoutTypes = types;
                this.customLayoutService.selectedLayoutType = types.find(t => t.Name == 'Behavior Quick Add');
                if (this.customLayoutService.selectedLayoutType) {
                    this.getBehaviorLayout();
                }
            }));
        } else {
            this.customLayoutService.selectedLayoutType = this.customLayoutService.layoutTypes.find(t => t.Name == 'Behavior Quick Add');
            if (this.customLayoutService.selectedLayoutType) {
                this.getBehaviorLayout();
            }
        }
    }

    getBehaviorLayout() {
        this.getBehaviorPreferences();

        this.schools = this.yearService.schools;

        this.customLayoutService.getCustomLayoutSchoolDefaults(this.customLayoutService.selectedLayoutType.Id).subscribe(result => {
            this.defaultSchoolLayouts = result.filter(x => this.schools.findIndex(o => o.Id == x.School_Domain) != -1);
            this.defaultSchoolLayouts.sort(function (a, b) {
                if (a.SchoolName < b.SchoolName) {
                    return -1;
                }
                if (a.SchoolName > b.SchoolName) {
                    return 1;
                }
            });

            this.customLayoutService.getLayoutsByType(this.customLayoutService.selectedLayoutType.Id, this.yearService.defaultYear.Id, false).subscribe(results => {
                this.layouts = results;
                let defaultLayoutId = 0;

                const defaultLayoutIndex: number = this.layouts.findIndex(layout => layout.TylerDefault == true);
                if (defaultLayoutIndex != -1) {
                    defaultLayoutId = this.layouts[defaultLayoutIndex].Id;
                }

                this.schools.forEach(school => {
                    const schoolDefaultIndex: number = this.defaultSchoolLayouts.findIndex(x => x.School_Domain == school.Id);

                    if (schoolDefaultIndex != -1) {
                        this.defaultSchoolLayouts[schoolDefaultIndex].SchoolName = school.SchoolName;
                    } else {
                        const defaultSchoolLayout: CustomLayoutSchoolDefault = new CustomLayoutSchoolDefault();
                        defaultSchoolLayout.Id = 0;
                        defaultSchoolLayout.LayoutType_Id = 2;
                        defaultSchoolLayout.Layout_Id = defaultLayoutId;
                        defaultSchoolLayout.SchoolName = school.SchoolName;
                        defaultSchoolLayout.School_Domain = school.Id;

                        this.defaultSchoolLayouts.push(defaultSchoolLayout);
                    }
                });

                this.defaultSchoolLayouts.sort(function (a, b) {
                    if (a.SchoolName < b.SchoolName) {
                        return -1;
                    }
                    if (a.SchoolName > b.SchoolName) {
                        return 1;
                    }
                });
            });
        });
    }

    saveBehaviorDefaultLayouts() {
        this.customLayoutService.saveDefaultSchoolLayouts(this.defaultSchoolLayouts).subscribe();
    }

    saveUserDefaultLayout() {
        this.behaviorPreferences = new BehaviorPreferences;
        this.behaviorPreferences.Layout_ID = this.defaultUserLayoutId;
        this.userPreferenceService.behaviorPreferences = this.behaviorPreferences;
        this.saveUserPreferences('/OneSISBehavior', this.behaviorPreferences, 0, '');
    }

    changeAllDefaultLayouts() {
        this.defaultSchoolLayouts.forEach(schoolLayout => {
            schoolLayout.Layout_Id = this.allLayoutsId;
        });
    }

    resetAllUsersToDefault() {
        const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
            disableClose: true,
        });
        deleteConfirmDialog.componentInstance.headerLabel = 'WARNING';
        deleteConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to reset all users to default layout for the district?';
        deleteConfirmDialog.componentInstance.confirmEvent.subscribe((deleteUserDefaults: boolean) => {
            if (deleteUserDefaults) {
                this.customLayoutService.setUserLayoutToDefault(this.customLayoutService.selectedLayoutType.Id).subscribe(result => {
                    this.sharedService.showCustomSnackbar('All users have been reset to the default layout.', 'success');
                });
            }
        });
    }

    checkShowPortal(portalName: string): boolean {
        if (this.staffAssignedPortalNames[portalName] != undefined) {
            return this.staffAssignedPortalNames[portalName];
        } else {
            return false;
        }
    }

    checkForChildPortals(portal: Portal): boolean {
        return this.staffAssignedPortals.filter(x => x.ParentId == portal.Id).length > 0;
    }

    isEven(rowId): boolean {
        return (rowId % 2) === 0;
    }

    expandDetailSection(sectionName: string) {
        if (this.rowDetailExpand[sectionName] != null) {
            this.rowDetailExpand[sectionName] = !this.rowDetailExpand[sectionName];
        } else {
            this.rowDetailExpand[sectionName] = false;
        }
    }

    closeClick() {
        if (this.selectedPreferenceTab == 'Favorites') {
            this.staffAssignedPortals = JSON.parse(JSON.stringify(this.staffAssignedPortalsCopy));
            this.classroom360Service.updateStaffAssignedPortals(this.staffAssignedPortals);
        }
        this.dialogRef.close('Close was clicked.');
    }

    expandAllClick(expandSection) {

        if (this.selectedPreferenceTab == 'General') {
            this.rowDetailExpand['ACTIVE DIRECTORY'] = expandSection;
            this.rowDetailExpand['CLASSES IN DROPDOWN'] = expandSection;
            this.rowDetailExpand['LOGIN'] = expandSection;
            this.rowDetailExpand['STUDENT ALERTS'] = expandSection;
            this.rowDetailExpand['STUDENT NAMES'] = expandSection;
            this.rowDetailExpand['STUDENT SEARCH'] = expandSection;
        }
        if (this.selectedPreferenceTab == 'Favorites') {
            this.appFavorites.expandAll(expandSection);
        } else if (this.selectedPreferenceTab == 'Gradebook') {
            this.rowDetailExpand['ADDING ASSIGNMENTS'] = expandSection;
            this.rowDetailExpand['ASSIGNMENT HEADING'] = expandSection;
            this.rowDetailExpand['ASSIGNMENT SORT'] = expandSection;
            this.rowDetailExpand['ASSIGNMENT SCORES'] = expandSection;
            this.rowDetailExpand['AUTO-SAVE'] = expandSection;
            this.rowDetailExpand['COLUMNS IN SCORES GRID'] = expandSection;
            this.rowDetailExpand['STUDENTS'] = expandSection;
            this.rowDetailExpand['COMMENTS'] = expandSection;
            this.rowDetailExpand['REPORTCARDGRADES'] = expandSection;
            this.rowDetailExpand['STANDARDS'] = expandSection;
            this.rowDetailExpand['FINAL GRADE CALCULATION'] = expandSection;
            this.rowDetailExpand['ROUNDING'] = expandSection;
        }
    }

    menuSelected(selection: string) {
        if (selection == 'Gradebook') {
            if (!this.userService.currentUser.UserIsTeacher && !this.isDefaultPreferences && !this.userGBPreferencesPermission()) {
                this.PrimaryTeacherWarningModal();
                this.selectedPreferenceTab = 'General';
                return;
            }
            if (this.myClasses.length == 0 && !this.isDefaultPreferences) {
                this.NoGradingClassesModal();
                if (this.additionalCourses.length == 0) {
                    this.selectedPreferenceTab = 'General';
                } else {
                    this.selectedPreferenceTab = selection;
                }
            } else {
                if (this.additionalCourses != undefined && this.additionalCourses.length > 0) {
                    this.AdditionalTeacherWarningModal();
                }
                this.selectedPreferenceTab = selection;
            }
        } else if (selection == 'Favorites') {
            this.staffAssignedPortalsCopy = JSON.parse(JSON.stringify(this.staffAssignedPortals));
            this.selectedPreferenceTab = selection;
        } else {
            this.selectedPreferenceTab = selection;
        }
    }

    AssignmentHeadingCheck(): boolean {
        return this.gradebookPreferences.AssignmentHeading.filter(x => x.Field == 'Summary' && x.value).length > 0;
    }

    validateField(Type: string) {
        let autoSaveDurationInt = 10;
        if (this.gradebookPreferences.AutoSaveDuration != undefined || this.gradebookPreferences.AutoSaveDuration == null) {
            autoSaveDurationInt = parseInt(this.gradebookPreferences.AutoSaveDuration, 10);
        }
        if (Type == 'Summary') {
            if (this.loginService.LoginSettings.C360GradebookAssignmentsLongSummary == false) {
                if (this.gradebookPreferences.SummaryCharacterCount < 1) {
                    this.gradebookPreferences.SummaryCharacterCount = 1;
                }
                if (this.gradebookPreferences.SummaryCharacterCount > 50) {
                    this.gradebookPreferences.SummaryCharacterCount = 50;
                }
            } else {
                if (this.gradebookPreferences.SummaryCharacterCount < 1) {
                    this.gradebookPreferences.SummaryCharacterCount = 1;
                }
                if (this.gradebookPreferences.SummaryCharacterCount > 1000) {
                    this.gradebookPreferences.SummaryCharacterCount = 1000;
                }
            }
        } else if (Type == 'AutoSaveDuration') {
            if (autoSaveDurationInt < 1) {
                this.gradebookPreferences.AutoSaveDuration = '1';
            }
            if (autoSaveDurationInt > 60) {
                this.gradebookPreferences.AutoSaveDuration = '60';
            }
        } else if (Type == 'FillBlankScoreValue') {
            if ($.isNumeric(this.gradebookPreferences.FillBlankScoreValue) == false) {
                this.gradebookPreferences.FillBlankScoreValue = 0;
            }
        }
    }

    changeGradePreferenceCourse() {
        this.getGradebookPreferences();
    }

    setCalculationValues() {
        if (this.gradebookPreferences.FGradeCalculationType == '1') {
            this.gradebookPreferences.SemesterFinalGradeCalculationPoints = '0';
            this.gradebookPreferences.SemesterFinalGradeCalculationCombo = '0';
        } else if (this.gradebookPreferences.FGradeCalculationType == '2') {
            this.gradebookPreferences.SemesterFinalGradeCalculationPoints = '1';
            this.gradebookPreferences.SemesterFinalGradeCalculationCombo = '0';
        } else if (this.gradebookPreferences.FGradeCalculationType == '3') {
            this.gradebookPreferences.SemesterFinalGradeCalculationPoints = '0';
            this.gradebookPreferences.SemesterFinalGradeCalculationCombo = '1';
        }
    }

    calculationTypeChanged() {
        if (this.warnIfCalculationPreferencesChanged) {
            this.CalculationPreferencesWarningModal();
        }
    }

    switchRCGType(type: string) {
        if (type == 'projection' && this.gradebookPreferences.ProjectFutureScores) {
            this.gradebookPreferences.ShowAllTerms = false;
            this.projectScoresDialog = this.dialog.open(ProjectScoresInfoComponent, {
                panelClass: 'tyl-mat-dialog',
                width: '600px'
            });
        } else if (this.gradebookPreferences.ShowAllTerms) {
            this.gradebookPreferences.ProjectFutureScores = false;
        }
    }

    userGBPreferencesPermission() {
        return false;
    }

    // ------------Modal window-----------------------
    SyncPreferencesClick() {
        this.syncPrefDialogRef = this.dialog.open(SyncPreferencesDialogComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
            maxWidth: '500px'
        });
        this.syncPrefDialogRef.componentInstance.syncPreferencesAcrossCourses = this.gradebookPreferences.SyncPreferencesAcrossCourses;

        this.syncPrefDialogRef.afterClosed().subscribe(result => {
            if (result != 'OK was clicked') {
                this.gradebookPreferences.SyncPreferencesAcrossCourses = !this.gradebookPreferences.SyncPreferencesAcrossCourses;
            }
        });
    }

    NoGradingClassesModal() {
        this.noGradingClassesDialogRef = this.dialog.open(NoGradingClassesDialogComponent, {
            panelClass: 'tyl-mat-dialog',
            width: '500px'
        });
    }

    CustomSortWarningModal() {
        if (this.gradebookPreferences.StudentSortOrder == 'Custom') {
            this.gradebookStudentSortOrderOptions = ['Course Add Date', 'Custom (Set custom order from Tools menu)', 'Status', 'StudentName'];
            this.customSortWarningDialogRef = this.dialog.open(CustomSortWarningDialogComponent, {
                panelClass: 'tyl-mat-dialog'
            });
        } else {
            this.gradebookStudentSortOrderOptions = ['Course Add Date', 'Custom', 'Status', 'StudentName'];
        }
    }

    AdditionalTeacherWarningModal() {
        this.additionalTeacherWarningDialogRef = this.dialog.open(AdditionalTeacherWarningDialogComponent, {
            panelClass: 'tyl-mat-dialog'
        });

        this.additionalTeacherWarningDialogRef.componentInstance.additionalTeacher = this.additionalTeacher;
        this.additionalTeacherWarningDialogRef.componentInstance.multipleAdditional = this.multipleAdditional;
        this.additionalTeacherWarningDialogRef.componentInstance.singleAdditional = this.singleAdditional;
        this.additionalTeacherWarningDialogRef.componentInstance.syncPreferencesAcrossCourses = this.gradebookPreferences.SyncPreferencesAcrossCourses;
        this.additionalTeacherWarningDialogRef.componentInstance.additionalTeacherClassFocus = this.additionalTeacherClassFocus;
    }

    PrimaryTeacherWarningModal() {
        this.primaryTeacherWarningDialogRef = this.dialog.open(PrimaryTeacherWarningDialogComponent, {
            panelClass: 'tyl-mat-dialog'
        });
    }

    CalculationPreferencesWarningModal() {
        this.calculationPreferenceWarningDialogRef = this.dialog.open(CalculationPreferenceWarningDialogComponent, {
            panelClass: 'tyl-mat-dialog',
            width: '500px'
        });
    }

    showStudentNumberCheck() {
        if (this.generalPreferences.ShowStudentNumber && this.attendancePreferences && this.attendancePreferences.AvailableColumns.filter(c => c == 'Student #').length > 0) {
            const studentNumberColumn = this.attendancePreferences.AvailableColumns.filter(c => c == 'Student #')[0];
            if (studentNumberColumn != undefined) {
                this.attendancePreferences.ColumnsToShow.push(studentNumberColumn);
                this.attendancePreferences.AvailableColumns = this.attendancePreferences.AvailableColumns.filter(c => c != 'Student #');
            }
        }
        this.setGradebookStudentNumberColumn();
    }

    attendanceRestrict(item: CdkDrag<string>) {
        if (item.data == 'Student Name' || item.data == 'Projected Enrollment') {
            return false;
        } else {
            return true;
        }
    }

    attendanceRestrictNumber(item: CdkDrag<string>) {
        if (item.data == 'Student Name' || item.data == 'Student #' || item.data == 'Projected Enrollment') {
            return false;
        } else {
            return true;
        }
    }

    fieldDrop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex);
        }
    }
    dropAssignmentSort(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.gradebookPreferences.AssignmentSort, event.previousIndex, event.currentIndex);
        // re-index the items
        for (let i = 0; i < this.gradebookPreferences.AssignmentSort.length; i++) {
            this.gradebookPreferences.AssignmentSort[i].LinkOrder = i;
        }
    }

    dropAssignmentHeading(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.gradebookPreferences.AssignmentHeading, event.previousIndex, event.currentIndex);
        // re-index the items
        for (let i = 0; i < this.gradebookPreferences.AssignmentHeading.length; i++) {
            this.gradebookPreferences.AssignmentHeading[i].LinkOrder = i;
        }
    }

    getStaticAttendanceColumnColor(column: string) {
        return column == 'Student Name' || column == 'Projected Enrollment' || (this.generalPreferences.ShowStudentNumber && column == 'Student #');
    }

    defaultForStandardsViewChange() {
        this.setDefaultForStandardsView = !this.setDefaultForStandardsView;
        if (this.setDefaultForStandardsView) {
            this.gradebookPreferences.DefaultForStandardsView = 'Show';
        } else {
            this.gradebookPreferences.DefaultForStandardsView = 'Hide';
        }
    }

    changeFillBlankScore() {
        this.errors = [];
        if (this.gradebookPreferences.FillBlankScores == 'Score') {
            this.gradebookPreferences.FillBlankScoreSpecialMarkId = '0';
        } else if (this.gradebookPreferences.FillBlankScores == 'SpecialMark') {
            this.gradebookPreferences.FillBlankScoreValue = null;
        }
    }

    showSchedulingTab() {
        return this.activateClassroom360 &&
            (
                this.staffAssignedPortalNames['Master Schedule']
                || this.staffAssignedPortalNames['Period Statistics']
                || this.staffAssignedPortalNames['Schedule Student List']
                || this.staffAssignedPortals['Classes By Course']
            );
    }

    showClassroomSummaryOption(option: string): boolean {
        if (this.staffAssignedPortalNames != null) {
            return this.staffAssignedPortalNames[option];
        }
        return false;
    }
}

@Pipe({
    name: 'portalFilter',
    pure: false
})
export class PortalFilterPipe implements PipeTransform {
    transform(items: Portal[]): any {
        // return items.filter(x => x.ShowAsMenu == true && x.ParentId == 0);
        return items.filter(x => x.ParentId == 0);
    }
}

@Pipe({
    name: 'tileFilter',
    pure: false
})
export class TileFilterPipe implements PipeTransform {
    transform(tiles: string[], staffAssignedPortalNames: string[]): any {
        // return items.filter(x => x.ShowAsMenu == true && x.ParentId == 0);
        return tiles.filter(name =>
            staffAssignedPortalNames[name]
        );
    }
}

@Pipe({
    name: 'childPortalFilter',
    pure: false
})
export class ChildPortalFilterPipe implements PipeTransform {
    transform(items: Portal[], filter: Object): any {
        return items.filter(x => x.ParentId == filter);
    }
}

@Pipe({
    name: 'schoolLayoutFilter',
    pure: false
})
export class SchoolLayoutFilterPipe implements PipeTransform {
    transform(items: CustomLayout[], filter: number): any {
        return items.filter(x =>
            x.SelectedSites == undefined ||
            x.SelectedSites.split(',').indexOf(filter.toString()) != -1);
    }
}

@Pipe({
    name: 'schoolLayoutAllFilter',
    pure: false
})
export class SchoolLayoutAllFilterPipe implements PipeTransform {
    transform(items: CustomLayout[], filter: number): any {
        return items.filter(x => x.SelectedSites == undefined);
    }
}
